import axios from "axios";
import authHeader from "@/services/auth-header";
import publicHeader from "@/services/public-header";

const API_URL = `${process.env.VUE_APP_API_BASE_URL}/api/Feature/LookUp`;

class LookUpService {
  getCompensationPlan(originationChannel) {
    const subUrl =
      originationChannel !== undefined
        ? `/CompensationPlan?originationChannel=${originationChannel}`
        : "/CompensationPlan";

    return axios
      .get(`${API_URL}${subUrl}`, {
        headers: authHeader(),
      })
      .then((response) => {
        return response;
      });
  }

  getCountyList() {
    return axios
      .get(`${API_URL}/CountyList`, {
        headers: authHeader(),
      })
      .then((response) => {
        return response;
      });
  }

  getBrokerCompPlanByOrganizationId(organizationId) {
    return axios
      .get(`${API_URL}/BrokerCompPlanByOrganizationId/${organizationId}`, {
        headers: authHeader(),
      })
      .then((response) => {
        return response;
      });
  }

  getBrokerCompPlanByFileData(fileData) {
    return axios
      .post(`${API_URL}/BrokerCompPlanByFileData`, fileData, {
        headers: authHeader(),
      })
      .then((response) => {
        return response;
      });
  }

  getMstCodeVM(codeType) {
    return axios
      .get(`${API_URL}/MstCodeVM?codeType=${codeType}`, {
        headers: publicHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  getLoanStatusPipeline() {
    return axios
      .get(`${API_URL}/LoanStatus/Pipeline`, {
        headers: publicHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  getHashTableMstCode() {
    return axios
      .get(`${API_URL}/HashTable/MstCode`, {
        headers: publicHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  getHashTableOrganization() {
    return axios
      .get(`${API_URL}/HashTable/Organization`, {
        headers: publicHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
}

export default new LookUpService();
